export enum LogLevel {
  DEBUG = "debug",
  INFO = "info",
  WARN = "warn",
  ERROR = "error",
}

export class Logger {
  private static getTimestamp(): string {
    return new Date().toISOString();
  }

  private static formatMessage(
    level: LogLevel,
    message: string,
    ...args: any[]
  ): void {
    const timestamp = this.getTimestamp();
    const prefix = `[${timestamp}] [${level.toUpperCase()}]`;

    switch (level) {
      case LogLevel.DEBUG:
        // eslint-disable-next-line no-console
        console.debug(prefix, message, ...args);
        break;
      case LogLevel.INFO:
        // eslint-disable-next-line no-console
        console.info(prefix, message, ...args);
        break;
      case LogLevel.WARN:
        // eslint-disable-next-line no-console
        console.warn(prefix, message, ...args);
        break;
      case LogLevel.ERROR:
        // eslint-disable-next-line no-console
        console.error(prefix, message, ...args);
        break;
    }
  }

  static debug(message: string, ...args: any[]): void {
    if (import.meta.env.DEV) {
      this.formatMessage(LogLevel.DEBUG, message, ...args);
    }
  }

  static info(message: string, ...args: any[]): void {
    this.formatMessage(LogLevel.INFO, message, ...args);
  }

  static warn(message: string, ...args: any[]): void {
    this.formatMessage(LogLevel.WARN, message, ...args);
  }

  static error(message: string, ...args: any[]): void {
    this.formatMessage(LogLevel.ERROR, message, ...args);
  }
}
